export default "__VITE_ASSET__7a8355d1__"